// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { IToggleStyles, Toggle } from '@fluentui/react';
import { useThemeName, useToggleTheme } from 'theme/SwitchableThemeProvider';

export const ThemeToggleButton = (): JSX.Element => {
  const currentThemeName = useThemeName();
  const toggleTheme = useToggleTheme();
  return (
    <Toggle
      inlineLabel
      onText="☀️"
      offText="🌙"
      onClick={toggleTheme}
      ariaLabel="Toggle Theme"
      checked={currentThemeName === 'Light'}
      styles={toggleButtonStyles}
    />
  );
};

const toggleButtonStyles: Partial<IToggleStyles> = {
  root: {
    marginBottom: 'unset'
  }
};
